/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ColDef } from 'ag-grid-community';

import { twoDecimalValueFormatter } from 'components/common/Tables/CommonGridFormatters';

export enum TrackTemperatureTableColId {
  CameraTakeTimestamp = 'cameraTakeTimestamp',
  CameraLocation = 'cameraLocation',
  LowLineTemperature = 'lowLineTemperature',
  MiddleLineTemperature = 'middleLineTemperature',
  HighLineTemperature = 'highLineTemperature',
  ReferenceTemperature = 'referenceTemperature',
}
export const trackTemperatureTableColDefs: ColDef[] = [
  {
    colId: TrackTemperatureTableColId.CameraTakeTimestamp,
    headerName: 'Time',
    flex: 1,
    sort: 'desc',
  },
  {
    colId: TrackTemperatureTableColId.LowLineTemperature,
    headerName: 'Low Line',
    flex: 1,
    type: 'numericColumn',
    valueFormatter: twoDecimalValueFormatter,
  },
  {
    colId: TrackTemperatureTableColId.MiddleLineTemperature,
    headerName: 'Mid Line',
    flex: 1,
    type: 'numericColumn',
    valueFormatter: twoDecimalValueFormatter,
  },
  {
    colId: TrackTemperatureTableColId.HighLineTemperature,
    headerName: 'High Line',
    flex: 1,
    type: 'numericColumn',
    valueFormatter: twoDecimalValueFormatter,
  },
  {
    colId: TrackTemperatureTableColId.ReferenceTemperature,
    headerName: 'Reference',
    flex: 1,
    type: 'numericColumn',
    headerTooltip: 'Reference track temperature, normally from apron or access road',
    valueFormatter: twoDecimalValueFormatter,
  },
];
